import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import contactPortalService from '../services/contactPortal';
import './ContactPortal.scss';

const ContactResendActivation = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    setSuccess('');

    try {
      const response = await contactPortalService.resendActivation(email.trim());
      setSuccess(response.message || 'Si el email corresponde a una cuenta pendiente, enviamos un nuevo enlace de activacion.');
    } catch (err) {
      const message = err.response?.data?.detail || 'No se pudo procesar la solicitud.';
      setError(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-portal-auth-page">
      <div className="auth-card">
        <h1>Reenviar activacion</h1>
        <p>Si tu cuenta aun no esta activa, te enviaremos un nuevo enlace.</p>

        <form onSubmit={onSubmit}>
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? 'Enviando...' : 'Reenviar enlace'}
          </button>
        </form>

        <p className="auth-footer">
          <Link to="/contactos/login">Volver a Login</Link>
        </p>
      </div>
    </div>
  );
};

export default ContactResendActivation;
